// useT.js — Translator hook bound to the current language tweak
import React from "react";
import { useTweaks } from "../hooks/useTweaks.js";
import { t as translate } from "./dict.js";

export function useT() {
  const [s] = useTweaks();
  return React.useCallback((k) => translate(k, s.lang), [s.lang]);
}
